import React from "react";
import { SkeletonCellType } from "./types";

interface SkeletonCellProps {
  type: SkeletonCellType;
  width?: string;
  customRender?: () => React.ReactElement;
}

export function SkeletonCell({
  type,
  width,
  customRender,
}: SkeletonCellProps) {
  if (type === "custom" && customRender) {
    return customRender();
  }

  switch (type) {
    case "text":
      return (
        <div
          className={`h-3.5 ${
            width || "w-48"
          } bg-[#1b2838] rounded animate-pulse`}
        />
      );

    case "number":
      return (
        <div
          className={`h-3 ${
            width || "w-16"
          } bg-[#1b2838] rounded animate-pulse`}
        />
      );

    case "image":
      return (
        <div className="w-[100px] h-[37px] flex-shrink-0">
          <div className="w-full h-full bg-[#1b2838] animate-pulse" />
        </div>
      );

    case "platforms":
      return (
        <div className="flex gap-1.5">
          <div className="w-4 h-4 bg-[#1b2838] rounded animate-pulse" />
          <div className="w-4 h-4 bg-[#1b2838] rounded animate-pulse" />
          <div className="w-4 h-4 bg-[#1b2838] rounded animate-pulse" />
        </div>
      );

    case "date":
      return (
        <div
          className={`h-3 ${
            width || "w-24"
          } bg-[#1b2838] rounded animate-pulse`}
        />
      );

    default:
      return <div className="h-3 w-16 bg-[#1b2838] rounded animate-pulse" />;
  }
}
